<template>
    <section v-if="totalPages > 1" class="pagination">
        <slot v-if="currentPage > 1">
            <button @click="previousPage()">Précédent</button>
        </slot>

        <slot v-if="currentPage >= 3">
            <button @click="changePage(1)">
                <IconFirstPage height="14px" width="14px"></IconFirstPage>
            </button>
        </slot>

        <button
            v-for="page in pagination"
            :key="page"
            :class="{ 'is-current-page': page === currentPage }"
            @click="changePage(page)"
        >
            <span>{{ page }}</span>
        </button>

        <slot v-if="currentPage + 2 < totalPages">
            <button @click="changePage(totalPages)">
                <IconLastPage height="14px" width="14px"></IconLastPage>
            </button>
        </slot>

        <slot v-if="currentPage < totalPages">
            <button @click="nextPage()">Suivant</button>
        </slot>
    </section>
</template>

<script>
import { state, getData } from "../store";
import { computed } from "vue";
import IconFirstPage from "./Icons/IconFirstPage.vue";
import IconLastPage from "./Icons/IconLastPage.vue";

export default {
    name: "Pagination",
    setup() {
        const totalPages = computed(() => {
            return state.pagination.totalPages;
        });

        const currentPage = computed(() => {
            return state.pagination.currentPage;
        });

        const pagination = computed(() => {
            let pageList = [];

            for (let i = 0; i <= totalPages.value; i++) {
                pageList.push(i);
            }

            if (totalPages.value > 3) {
                pageList = pageList.slice(currentPage.value, currentPage.value + 3);
            }

            return pageList;
        });

        const listHtml = document.querySelector("#map");

        const changePage = async (page) => {
            state.pagination.currentPage = page;
            await getData(state.pagination.currentPage);
            listHtml.scrollIntoView({ behavior: "smooth", block: "start" });
        };

        const previousPage = async () => {
            state.pagination.currentPage = state.pagination.currentPage - 1;
            await getData(state.pagination.currentPage);
            listHtml.scrollIntoView({ behavior: "smooth", block: "start" });
        };

        const nextPage = async () => {
            state.pagination.currentPage = state.pagination.currentPage + 1;
            await getData(state.pagination.currentPage);
            listHtml.scrollIntoView({ behavior: "smooth", block: "start" });
        };

        return { state, currentPage, pagination, totalPages, changePage, previousPage, nextPage };
    },
    components: { IconFirstPage, IconLastPage }
}
</script>

<style scoped lang="scss">
@import "../scss/_variables.scss";

.pagination {
    margin: 1.5em 0;
    text-align: center;
    .is-current-page {
        font-weight: bold;
        background-color: $base-color;
        color: white;
    }

    button {
        margin: 0 0.3em;
        padding: 0.7em 1em;
        border-radius: 4px;
        border: none;
    }
    button:hover {
        background-color: rgb(221, 221, 221);
    }
}
</style>